import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';

const Navdata = () => {
  const navigate = useNavigate();
  const role = "SUPER";
  const [isDashboard, setIsDashboard] = useState(false);
  const [isManageClient, setIsManageClient] = useState(false);
  const [IsManageCertificationsXzlenz, setIsManageCertificationsXzlenz] = useState(false);
  const [IsManageCertificationsDhanush, setIsManageCertificationsDhanush] = useState(false);
  const [isManageNotification, setIsManageNotification] = useState(false);
  const [isManageSupport, setIsManageSupport] = useState(false);
  const [isCurrentState, setIsCurrentState] = useState("Dashboard");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (isCurrentState !== "Dashboard") setIsDashboard(false);
    if (isCurrentState !== "ManageClient") setIsManageClient(false);
    if (isCurrentState !== "ManageCertificationsXzlenz") setIsManageCertificationsXzlenz(false);
    if (isCurrentState !== "ManageCertificationsDhanush") setIsManageCertificationsDhanush(false);
    if (isCurrentState !== "ManageNotification") setIsManageNotification(false);
    if (isCurrentState !== "ManageSupport") setIsManageSupport(false);
  }, [
    isDashboard,
    isManageClient,
    IsManageCertificationsXzlenz,
    IsManageCertificationsDhanush,
    isManageNotification,
    isManageSupport,
    navigate,
  ]);

  const rolePermissions = {
    SUPER: ["dashboard", "manageClient", "manageCertificationsXzlenz", "manageCertificationsDhanush", "manageNotification", "manageSupport"],
  };

  const menuItems = [
    { label: "Menu", isHeader: true, items: ["dashboard", "manageClient"] },
    {
      id: "dashboard",
      label: "Dashboard",
      icon: "bx bxs-dashboard",
      link: "/dashboard",
      stateVariables: isDashboard,
      click: (e) => {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIsCurrentState("Dashboard");
        updateIconSidebar(e);
      },
    },
    {
      id: "manageClient",
      label: "Manage Client",
      icon: "bx bx-user-pin",
      link: "/clients-list",
      stateVariables: isManageClient,
      click: function (e) {
        e.preventDefault();
        setIsManageClient(!isManageClient);
        setIsCurrentState("ManageClient");
        updateIconSidebar(e);
      },
    },
    { label: "Xzlenz", isHeader: true, items: ["manageCertificationsXzlenz"] },
    {
      id: "manageCertificationsXzlenz",
      label: "Manage Certifications",
      icon: "bx bxs-detail",
      link: "/clients-list",
      stateVariables: IsManageCertificationsXzlenz,
      click: function (e) {
        e.preventDefault();
        setIsManageCertificationsXzlenz(!IsManageCertificationsXzlenz);
        setIsCurrentState("ManageCertificationsXzlenz");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "manageCompliance",
          label: "Manage Compliance",
          link: "/manage-compliance",
          parentId: "manageCertificationsXzlenz",
        },
        {
          id: "manageCCFPoints",
          label: "Manage CCF Points",
          link: "/manage-cff-points",
          parentId: "manageCertificationsXzlenz",
        },
      ]
    },
    { label: "Dhanush", isHeader: true, items: ["manageCertificationsDhanush"] },
    {
      id: "manageCertificationsDhanush",
      label: "Manage Certifications",
      icon: "bx bxs-detail",
      link: "/clients-list",
      stateVariables: IsManageCertificationsDhanush,
      click: function (e) {
        e.preventDefault();
        setIsManageCertificationsDhanush(!IsManageCertificationsDhanush);
        setIsCurrentState("ManageCertificationsDhanush");
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "manageCompliance",
          label: "Manage Framework",
          link: "/manage-framework",
          parentId: "manageCertificationsDhanush",
        },
        {
          id: "manageCCFPoints",
          label: "Manage Commands",
          link: "/manage-commands",
          parentId: "manageCertificationsDhanush",
        },
      ]
    },
    { label: "Support & Notification", isHeader: true, items: ["manageNotification", "manageSupport"] },
    {
      id: "manageNotification",
      label: "Manage Notification",
      icon: "bx bxs-bell",
      link: "/notifications",
      stateVariables: isManageNotification,
      click: function (e) {
        e.preventDefault();
        setIsManageNotification(!isManageNotification);
        setIsCurrentState("ManageNotification");
        updateIconSidebar(e);
      },
    },
    {
      id: "manageSupport",
      label: "Manage Support",
      icon: "bx bx-support",
      link: "/support",
      stateVariables: isManageSupport,
      click: function (e) {
        e.preventDefault();
        setIsManageSupport(!isManageSupport);
        setIsCurrentState("ManageSupport");
        updateIconSidebar(e);
      },
    },
  ];

  const filteredMenuItems = menuItems.filter((item) => {
    if (item.isHeader) {
      return item.items.some((subItem) => rolePermissions[role]?.includes(subItem));
    } else {
      return rolePermissions[role]?.includes(item.id);
    }
  });

  return <React.Fragment>{filteredMenuItems}</React.Fragment>;
};
export default Navdata;